define('helpers/browserDetection',['require','exports','module'],function (require, exports, module) {
  'use strict';

  var IEXPLORER_SUPPORTED = 10;

  var browserDetection = function () {
    var browser = get_browser_info();
    var urlRedirection = $.i18n.translate('PUBLIC.REDIRECTION_URL');

    if (browser.name === 'MSIE' && browser.version < IEXPLORER_SUPPORTED) {
      window.location.replace('http://' + urlRedirection);
    }
  };

  var get_browser_info = function () {
    var userAgent = navigator.userAgent, tem,
        matched = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(matched[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return {name: 'IE ', version: (tem[1] || '')};
    }

    if (matched[1] === 'Chrome') {
      tem = userAgent.match(/\bOPR\/(\d+)/);
      if (tem !== null) {
        return {name: 'Opera', version: tem[1]};
      }
    }

    matched = matched[2] ? [matched[1], matched[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = userAgent.match(/version\/(\d+)/i)) !== null) {
      matched.splice(1, 1, tem[1]);
    }

    return {
      name: matched[0],
      version: matched[1]
    };
  };

  module.exports = browserDetection;
});

